import clauseManagementSvg from "../assets/sidebar/clauseManagement.svg";
import clauseManagementSelectedSvg from "../assets/sidebar/clauseManagement_selected.svg";

import dashboardNewSvg from "../assets/images/dashboardNewInactive.svg";
import dashboardNewSelected from "../assets/images/dashboardNewActive.svg";
import dashboardNewAltSvg from "../assets/images/dashboardNewAlt.svg";
import dashboardActiveSvg from "../assets/images/dashboardActive.svg";
import verizonDashboardIcon from "../assets/images/verizonDashboardIcon.svg";
import veriozonSelected from "../assets/images/verizonDashboardIcon.svg";
import redliningSvg from "../assets/images/redliningNewInactive.svg";
import redliningSelectedSvg from "../assets/images/redliningNewActive.svg";
import clauseCheckSvg from "../assets/images/clauseCheckNewInactive.svg";
import clauseCheckSelectedSvg from "../assets/images/clauseCheckNewActive.svg";
import adminPanelSvg from "../assets/images/adminPanel.svg";
import adminPanelSelectedSvg from "../assets/images/adminPanelActive.svg";

import bulkUploadSvg from "../assets/sidebar/bulkUpload.svg";
import clauseSummarySvg from "../assets/sidebar/clauseSummary.svg";

import userManagementSvg from "../assets/sidebar/manage_accounts.svg";
import userManagementSelectedSvg from "../assets/sidebar/manage_accounts_selected.svg";

import Error404SVG from "../assets/images/Error404.svg";
import { SidebarOption, UploadConfig } from "./types";
import { UserRolesKey } from "../modules/Admin/constants";
import { LANDING_PAGE_TO_DASHBOARD_URLS } from "../modules/vscDashboard/constants";

export const UPLOAD_FILES_TO_CHAT_PROMPT_TEXT =
  "Upload files to enter the chat...";

export const noDataTextForKeyContractClause =
  "There are no contracts uploaded yet. Please upload contract to get started with review.";
export const VscDashboards = [
  {
    text: "VSC Dashboard Risk",
    disabled: false,
  },
];

export const FILE_UPLOAD_ERRORS = {
  DOC_FILE_SUPPORT_ONLY: "Allowed types include only .docx file. ",
  PDF_FILE_SUPPORT_ONLY: "Allowed types include only .pdf file. ",
  XLXS_FILE_SUPPORT_ONLY: "Allowed types include only .xlsx file. ",
  EXCEEDS_SIZE_CANNOT_EXCEED_10MB: "File(s) size exceeds 10MB. ",
  SIZE_EXCEEDS_25MB: "File(s) size exceeds 25 MB. ",
  NUMBER_OF_FILES_LIMIT_REACHED: "You can only upload upto 50 files. ",
  PDF_IS_NOT_SUPPORTED: "PDF files are not supported. ",
};

//10 MB
export const FILE_SIZE_LIMIT_10_MB = 10 * 1024 * 1024;
// 25 MB
export const FILE_SIZE_LIMIT_25_MB = 25 * 1024 * 1024;
//100 MB
export const FILE_SIZE_LIMIT_100_MB = 100 * 1024 * 1024;

export const FILES_LIMIT_FROM_DRIVE_UPLOAD = 50;

export const MimeTypes = {
  gDoc: "application/vnd.google-apps.document",
  gFolder: "application/vnd.google-apps.folder",
  gFile: "application/vnd.google-apps.file",
  pdf: "application/pdf",
  doc: "application/msword",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  excel: "application/vnd.ms-excel",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
};

export const avatarStyleForCount = {
  primary: {
    border: "1px solid #E6A800",
    color: "#E6A800",
    background: "#E6A8000D",
  },
  nonPrimary: {
    border: "1px solid #0E9D58",
    color: "#0E9D58",
    background: "#0E9D580D",
  },
};

export const PROTECTED = "PROTECTED";

export const LOCAL_STORAGE_KEYS = {
  USER_META_DATA: "USER_META_DATA",
  ACCESS_TOKEN: "ACCESS_TOKEN",
  REFRESH_TOKEN: "REFRESH_TOKEN",
  GOOGLE_AUTH_TOKEN: "GOOGLE_AUTH_TOKEN",
  GOOGLE_ACCESS_TOKEN: "GOOGLE_ACCESS_TOKEN",
  GOOGLE_REFRESH_TOKEN: "GOOGLE_REFRESH_TOKEN",
  DATE_TIME_FORMAT: "DATE_TIME_FORMAT",
  AGENTIC_CONVERSATION_ID: "AGENTIC_CONVERSATION_ID",
};

export const TIMEOUT_MILLISECONDS = 60 * 60 * 1000;
export const GENERAL_DEBOUNCE_TIME = 500;
export const SECONDS_TO_REFRESH_TOKEN = 30;

export const ROUTES = {
  dashboard: "/",
  login: "/login",
  doc: "/doc",
  manageContracts: "/manage-contract",
  bulkClauseCheck: "/bulk-clause-check",
  clauseSummary: "/clause-summary",
  profile: "/profile",
  adminDashboard: "/admin-dashboard",
  clauseCheckDoc: "/clause-check-doc",
  clauseManagement: "/clause-management",
  manageRole: "/manage-role",
  dashboardTabs: "/dashboard",
  // contractRedliningDashboard: "/dashboard?cardType=contract_redlining",
  contractRedliningDashboard: "/dashboard?cardType=contract_review",
  keyContractClausesDashboard: "/dashboard?cardType=clause_check",
  contractDrafting: "/dashboard?cardType=contract_drafting",
  rfxEvaluationDashboard: "/dashboard?cardType=rfx_evaluation",
  rfxEvaluation: "/rfx-evaluation",
  rfxGenerator: "/dashboard?cardType=rfx_generator",
  demoLandingPage: "/demo",
  error: "*",
  chatbot: "/chatbot",
  sourcingHubDashboard: "/gsa-dashboard",
  workBenchTable: "/work-bench-table",
  workbenchDashboard: "/workbench-dashboard",
  sourcingHubChat: "/ask-orion",
  workbenchDashboardRequestForm: "/workbench-dashboard/request-form",
};

export const breadCrumbData = {
  dashboard: { text: "Dashboard", link: ROUTES.dashboard },
  rfxGeneratorDashboard: {
    text: "RFx Generator",
    link: ROUTES.rfxGenerator,
  },
  contractDraftingDashboard: {
    text: "Contract Drafting",
    link: ROUTES.contractDrafting,
  },
  contractRedliningDashboard: {
    text: "Contract Review",
    link: ROUTES.contractRedliningDashboard,
  },
  keyContractClausesDashboard: {
    text: "Key Contract Clauses",
    link: ROUTES.keyContractClausesDashboard,
  },
  manageContracts: {
    text: "All Contracts",
    link: ROUTES.manageContracts,
  },
  bulkUpload: {
    text: "Bulk Upload",
    link: ROUTES.bulkClauseCheck,
  },

  clauseSummary: {
    text: "Clause Summary",
    link: ROUTES.clauseSummary,
  },

  profile: {
    text: "Profile",
    link: ROUTES.profile,
  },

  userManagment: {
    text: "User Managment",
    link: ROUTES.adminDashboard,
  },

  clauseManagement: {
    text: "Clause Management",
    link: ROUTES.clauseManagement,
  },

  manageRole: {
    text: "Manage Role",
    link: ROUTES.manageRole,
  },

  contractReview: {
    text: "Contract Review",
    // link: ROUTES.manageRole,
  },

  // contractRedliningDashboard: {
  //   text: "Contract Review",
  //   // link: ROUTES.dashboardTabs + "?cardType=" + LANDING_PAGE_TO_DASHBOARD_URLS.contract_redlining,
  // },

  clausesDashboard: {
    text: "Key Contract Clauses",
    // link: ROUTES.dashboardTabs + "?cardType=" + LANDING_PAGE_TO_DASHBOARD_URLS.clause_check,
  },
};

export const sidebarContent: SidebarOption = {
  dashboard: {
    active: dashboardNewSelected,
    inactive: dashboardNewSvg,
    title: "Home",
    url: ROUTES.dashboard,
    supportUrls: [ROUTES.dashboard],
    showFor: [
      UserRolesKey.ADMIN,
      UserRolesKey.REDLINING_USER,
      UserRolesKey.CLAUSE_CHECK_USER,
    ],
  },
  contract: {
    active: redliningSelectedSvg,
    inactive: redliningSvg,
    title: "Contract Review",
    url: ROUTES.manageContracts,
    supportUrls: [ROUTES.doc],
    showFor: [UserRolesKey.ADMIN, UserRolesKey.CLAUSE_CHECK_USER],
  },
  clause: {
    active: clauseCheckSelectedSvg,
    inactive: clauseSummarySvg,
    title: "Clause Summary",
    url: ROUTES.clauseSummary,
    supportUrls: [ROUTES.clauseSummary, ROUTES.clauseCheckDoc],
    showFor: [UserRolesKey.ADMIN, UserRolesKey.CLAUSE_CHECK_USER],
  },
  admin: {
    active: adminPanelSelectedSvg,
    inactive: adminPanelSvg,
    title: "Manage",
    url: ROUTES.bulkClauseCheck,
    supportUrls: [ROUTES.adminDashboard, ROUTES.clauseManagement],
    showFor: [UserRolesKey.ADMIN],
    childNavs: [
      {
        title: "User Management",
        url: ROUTES.adminDashboard,
        supportUrls: [ROUTES.manageRole],
        showFor: [UserRolesKey.ADMIN],
        active: userManagementSvg,
      },
      {
        title: "Clause Management",
        url: ROUTES.clauseManagement,
        supportUrls: [ROUTES.clauseManagement],
        showFor: [UserRolesKey.ADMIN],
        active: clauseManagementSvg,
      },
    ],
  },
  cpoDashboard: {
    active: dashboardActiveSvg,
    inactive: verizonDashboardIcon,
    title: "CPO Dashboard",
    url: ROUTES.demoLandingPage,
    supportUrls: [ROUTES.demoLandingPage],
    showFor: [
      UserRolesKey.ADMIN,
      UserRolesKey.REDLINING_USER,
      UserRolesKey.CLAUSE_CHECK_USER,
    ],
  },
  sourcingHubDashboard: {
    active: dashboardActiveSvg,
    inactive: veriozonSelected,
    title: "Orion GSA",
    url: ROUTES.sourcingHubDashboard,
    supportUrls: [ROUTES.sourcingHubDashboard],
    showFor: [
      UserRolesKey.ADMIN,
      UserRolesKey.REDLINING_USER,
      UserRolesKey.CLAUSE_CHECK_USER,
    ],
  },
};

export const sideBarContentForAdmin: SidebarOption = {
  dashboard: {
    active: dashboardNewSelected,
    inactive: dashboardNewSvg,
    title: "Dashboard",
    url: ROUTES.dashboard,
    supportUrls: [ROUTES.dashboard],
    showFor: [
      UserRolesKey.ADMIN,
      UserRolesKey.REDLINING_USER,
      UserRolesKey.CLAUSE_CHECK_USER,
    ],
  },
  userManagement: {
    active: userManagementSelectedSvg,
    inactive: userManagementSvg,
    url: ROUTES.adminDashboard,
    supportUrls: [ROUTES.manageRole],
    title: "User Management",
    showFor: [UserRolesKey.ADMIN],
  },
  clauseManagement: {
    active: clauseManagementSelectedSvg,
    inactive: clauseManagementSvg,
    url: ROUTES.clauseManagement,
    supportUrls: [ROUTES.clauseManagement],
    title: "Clause Management",
    showFor: [UserRolesKey.ADMIN],
  },
};

export const USER_ROLES = {
  RISK: "Vendor Solutions Consultant - Risk",
  CONTRACT: "Vendor Solutions Consultant - Contracts",
};

export const DASHBOARD_ENTITIES = {
  CONTRACT_REVIEW: "contractReview",
  CLAUSE_CHECK: "clauseCheck",
  CONTRACT_DRAFTING: "contractDrafting",
  RFX_EVALUATION: "rfxEvaluation",
  RFX_GENERATOR: "rfxGenerator",
  TALK_TO_CONTRACT: "talkToContract",
};

export const UploadDocConfig: UploadConfig = {
  [DASHBOARD_ENTITIES.TALK_TO_CONTRACT]: {
    dropZoneProps: {
      maxFiles: 50,
      multiple: true,
      disabled: false,
      accept: {
        [MimeTypes.pdf]: [".pdf"],
        [MimeTypes.docx]: [".docx"],
        [MimeTypes.doc]: [".doc"],
        [MimeTypes.gDoc]: [],
      },
      driveMultiSelect: true,
      maxSize: FILE_SIZE_LIMIT_10_MB,
      uploadWarningText:
        "Files uploaded should be PDFs or DOCX and must not exceed 10MB.",
      fileTypeError: "Allowed types include only PDF and DOCX.",
      fileSizeError: FILE_UPLOAD_ERRORS.EXCEEDS_SIZE_CANNOT_EXCEED_10MB,
    },
    driveMimeTypes: [
      MimeTypes.pdf,
      MimeTypes.docx,
      MimeTypes.gFile,
      MimeTypes.gFolder,
      MimeTypes.gDoc,
    ].join(","),
  },
  [DASHBOARD_ENTITIES.CONTRACT_REVIEW]: {
    dropZoneProps: {
      maxFiles: 1,
      multiple: false,
      disabled: false,
      accept: {
        [MimeTypes.doc]: [".doc"],
        [MimeTypes.docx]: [".docx"],
        [MimeTypes.gDoc]: [],
      },
      driveMultiSelect: false,
      maxSize: FILE_SIZE_LIMIT_10_MB,
      uploadWarningText:
        "Files uploaded are restricted to DOCX format and must not exceed 10MB file size. Only Single File upload is supported.",
      fileSizeError: FILE_UPLOAD_ERRORS.EXCEEDS_SIZE_CANNOT_EXCEED_10MB,
      fileTypeError: FILE_UPLOAD_ERRORS.DOC_FILE_SUPPORT_ONLY,
    },
    driveMimeTypes: [MimeTypes.doc, MimeTypes.docx, MimeTypes.gDoc].join(","),
  },
  [DASHBOARD_ENTITIES.CLAUSE_CHECK]: {
    dropZoneProps: {
      maxFiles: 50,
      multiple: true,
      disabled: false,
      accept: {
        [MimeTypes.pdf]: [".pdf"],
      },
      driveMultiSelect: true,
      maxSize: FILE_SIZE_LIMIT_10_MB,
      uploadWarningText:
        "Files that can be uploaded are restricted to PDFs. Multi-file upload is supported.",
      fileSizeError: FILE_UPLOAD_ERRORS.EXCEEDS_SIZE_CANNOT_EXCEED_10MB,
      fileTypeError: FILE_UPLOAD_ERRORS.PDF_FILE_SUPPORT_ONLY,
    },
    driveMimeTypes: [MimeTypes.pdf, MimeTypes.gFile, MimeTypes.gFolder].join(
      ","
    ),
  },
  [DASHBOARD_ENTITIES.CONTRACT_DRAFTING]: {
    dropZoneProps: {
      maxFiles: 1,
      multiple: false,
      disabled: false,
      accept: {
        [MimeTypes.excel]: [".xlsx", ".xls"],
      },
      driveMultiSelect: false,
      maxSize: FILE_SIZE_LIMIT_10_MB,
      uploadWarningText:
        "Files that can be uploaded are restricted to XLSX format. Only Single File upload is supported.",
      fileSizeError: FILE_UPLOAD_ERRORS.EXCEEDS_SIZE_CANNOT_EXCEED_10MB,
      fileTypeError: FILE_UPLOAD_ERRORS.XLXS_FILE_SUPPORT_ONLY,
    },
    driveMimeTypes: [
      MimeTypes.xlsx,
      MimeTypes.excel,
      MimeTypes.gFile,
      MimeTypes.gFolder,
    ].join(","),
  },
  [DASHBOARD_ENTITIES.RFX_EVALUATION]: {
    dropZoneProps: {
      maxFiles: 50,
      multiple: true,
      disabled: false,
      accept: {
        [MimeTypes.pdf]: [".pdf"],
      },
      driveMultiSelect: true,
      maxSize: FILE_SIZE_LIMIT_25_MB,
      uploadWarningText:
        "Files that can be uploaded are restricted to PDFs. Multi-file upload is supported.",
      fileTypeError: FILE_UPLOAD_ERRORS.PDF_FILE_SUPPORT_ONLY,
      fileSizeError: FILE_UPLOAD_ERRORS.SIZE_EXCEEDS_25MB,
    },
    driveMimeTypes: [MimeTypes.pdf, MimeTypes.gFile, MimeTypes.gFolder].join(
      ","
    ),
  },
  [DASHBOARD_ENTITIES.RFX_GENERATOR]: {
    dropZoneProps: {
      maxFiles: 1,
      multiple: false,
      disabled: false,
      accept: {
        [MimeTypes.excel]: [".xlsx", ".xls"],
      },
      driveMultiSelect: false,
      maxSize: FILE_SIZE_LIMIT_10_MB,
      uploadWarningText:
        "Files that can be uploaded are restricted to XLSX format. Only Single File upload is supported.",
      fileSizeError: FILE_UPLOAD_ERRORS.EXCEEDS_SIZE_CANNOT_EXCEED_10MB,
      fileTypeError: FILE_UPLOAD_ERRORS.XLXS_FILE_SUPPORT_ONLY,
    },
    driveMimeTypes: [
      MimeTypes.xlsx,
      MimeTypes.excel,
      MimeTypes.gFile,
      MimeTypes.gFolder,
    ].join(","),
  },
};

export const ErrorType = {
  NOT_FOUND: "not-found",
  ACCESS_DENIED: "access-denied",
};

export const ErrorConfig = {
  [ErrorType.NOT_FOUND]: {
    errorCode: 404,
    errorTitle: "That's an error",
    errorText: {
      prefix: "The Requested URL",
      suffix: "was not found on this server. Thats all we know",
    },
    errorImg: Error404SVG,
  },
  [ErrorType.ACCESS_DENIED]: {
    errorCode: 403,
    errorTitle: "Access Denied",
    errorText: {
      prefix: "Seems Like you don't have access to this page.",
      suffix: "",
    },
    errorImg: Error404SVG,
  },
};

export const dummyResponse = {
  rfp_document: [
    {
      file_name: "5.11 Agency Partner RFI Final 3.4.24 RFP.pdf",
      entry_id: "88637631-bfdc-46aa-8597-6c3e04c389e3",
      gcs_location:
        "rfx_evaluation/rfx_uploaded_files/5.11 Agency Partner RFI Final 3.4.24 RFP_20250407115356.pdf",
      drive_location:
        "https://drive.google.com/file/d/1Ty4O_1rydnOfLVAXkcFdiK-QmNgzZgfCmC6nPuv1Uxw/view?usp=sharing",
    },
  ],
  scorecard: [
    {
      file_name: "Brand Agency Scorecard.pdf",
      entry_id: "96844798-977e-4476-bad2-1b8c54422051",
      gcs_location:
        "rfx_evaluation/rfx_uploaded_files/Brand Agency Scorecard_20250407115405.pdf",
      drive_location:
        "https://drive.google.com/file/d/1ZOkT84DGnYfIPYqi0HW8qk6mO1lF_OGCd5urww93pxw/view?usp=sharing",
    },
  ],
  response_doc: [
    {
      file_name:
        "Samsung Galaxy Launch Deck Shortlist_3.6.25-compressed RFP Response.pdf",
      entry_id: "ffd327af-4d39-40ad-b7e8-61f9e70ce481",
      gcs_location:
        "rfx_evaluation/rfx_uploaded_files/Samsung Galaxy Launch Deck Shortlist_3.6.25-compressed RFP Response_20250407115341.pdf",
      drive_location:
        "https://drive.google.com/file/d/1S6sGUDgP-hwHzXd4X1e2VEV7fHd3yNAC3e486XE7ws0/view?usp=sharing",
    },
    {
      file_name:
        "Deloitte Digital for AAA MWG_CreativeAOR_RFPResonse_10.23.24_LowRes copy RFP Response.pdf",
      entry_id: "bdbe9efa-41ef-49dc-99c8-7ae987657f35",
      gcs_location:
        "rfx_evaluation/rfx_uploaded_files/Deloitte Digital for AAA MWG_CreativeAOR_RFPResonse_10.23.24_LowRes copy RFP Response_20250407115412.pdf",
      drive_location:
        "https://drive.google.com/file/d/1IUAxnUerefA0SnMqB7uu8OYwHpAw2bVCkERjzsLUEbI/view?usp=sharing",
    },
    {
      file_name:
        "DD_5.11 Tactical_Presentation_051423 LowRes copy RFP Response.pdf",
      entry_id: "6e972d0e-1bfb-4509-ac7d-b4cc460b0ba5",
      gcs_location:
        "rfx_evaluation/rfx_uploaded_files/DD_5.11 Tactical_Presentation_051423 LowRes copy RFP Response_20250407115425.pdf",
      drive_location:
        "https://drive.google.com/file/d/1FrftYWyHVKkAVnfyvWYTzXhLgw2OOMEbAnjmS12gHd0/view?usp=sharing",
    },
    {
      file_name:
        "DeloitteDigital for Lidl_VendorQ&A_3.22.34 copy RFP Response.pdf",
      entry_id: "a23b522c-7a1b-4831-ad74-a79018993177",
      gcs_location:
        "rfx_evaluation/rfx_uploaded_files/DeloitteDigital for Lidl_VendorQ&A_3.22.34 copy RFP Response_20250407115529.pdf",
      drive_location:
        "https://drive.google.com/file/d/1_AEHhlgVztHPRwq1BpX6xK52pFWikdpuFUURl13uHXI/view?usp=sharing",
    },
    {
      file_name:
        "Deloitte Digital_Alarm.comI_11.10.21.FINAL copy RFP Response.pdf",
      entry_id: "695a8b3f-39fe-4ea7-b144-aa93338d1593",
      gcs_location:
        "rfx_evaluation/rfx_uploaded_files/Deloitte Digital_Alarm.comI_11.10.21.FINAL copy RFP Response_20250407115547.pdf",
      drive_location:
        "https://drive.google.com/file/d/1brmxLrEliZ1Gmf0X5tVE30vFd3BaE4IXr0_ojN7zJE8/view?usp=sharing",
    },
  ],
};

export const dummyDataset = {
  datasets: [
    {
      labels: [
        "Experience & general capabilities",
        "Case Studies",
        "Partnership Potential",
      ],
      data: [10, 12, 8],
      backgroundColor: ["#2E64DE33", "#2E64DE99", "#2E64DE"],
      borderColor: ["#2E64DE33", "#2E64DE99", "#2E64DE"],
      borderWidth: 1,
      // borderRadius: "8",
      borderJoinStyle: "round",
    },
  ],
};

export const chartColors: any = {
  blue: ["#2E64DE33", "#2E64DE99", "#2E64DE", "#F2F6FF"],
  green: ["#34A85333", "#34A85399", "#34A853", "#CEE6D5"],
};

export const REMOVE_TOKENS = {
  LOCAL_STORAGE_KEYS: [
    LOCAL_STORAGE_KEYS.ACCESS_TOKEN,
    LOCAL_STORAGE_KEYS.REFRESH_TOKEN,
  ],
};
